import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import Loader from './Loader';

/* Marking a request solved: "who helped?" — the people who replied, yourself,
   or skip. One optional tap that tells us B/N actually helped someone. */
export default function SolvedPicker({ postId, notify, onDone, onCancel }) {
  const [people, setPeople] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.requestHelpers(postId).then(setPeople).catch(() => setPeople([])); }, [postId]);
  async function solve(helpedBy, label) {
    setBusy(true);
    try {
      await api.resolveRequest(postId, helpedBy);
      notify?.(label);
      onDone?.();
    } catch (e) { notify?.(e.message); } finally { setBusy(false); }
  }
  return (
    <div className="solved-pick" role="group" aria-label="Who helped?">
      <b>Solved. Who helped?</b>
      <span className="muted-sm">Optional. They get the credit, and it shows B/N is working.</span>
      <div className="solved-opts">
        {people === null && <Loader inline delay={0} />}
        {(people || []).map((p) => (
          <button key={p.id} type="button" className="solved-opt" disabled={busy}
            onClick={() => solve(p.id, `Solved — thanks to ${p.name.split(' ')[0]}`)}>{p.name}</button>
        ))}
        <button type="button" className="solved-opt" disabled={busy} onClick={() => solve('self', 'Marked solved — nice')}>Solved it myself</button>
        <button type="button" className="linklike" disabled={busy} onClick={() => solve(null, 'Marked solved')}>Skip</button>
        {onCancel && <button type="button" className="linklike" onClick={onCancel}>Cancel</button>}
      </div>
    </div>
  );
}
